<template>
  <ul :class="$style.list">
    <li :class="$style.list__item" v-for="(todo, index) in todos" :key="index">
      <TodoListItem :item="todo" :viewer="viewer" />
    </li>
  </ul>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import TodoListItem from './TodoListItem.vue'
import type { TodoItem } from './type'
import type { TodoListViewerFragment } from './TodoList.generated'
import { useLogger } from '@/logger/logger'

const props = withDefaults(
  defineProps<{
    isFinishedSettingProfile?: boolean
    viewer: TodoListViewerFragment
  }>(),
  {
    isFinishedSettingProfile: true,
  }
)

const logger = useLogger()

const todos = computed((): TodoItem[] => {
  const links: Array<{ item: TodoItem; show: boolean }> = [
    {
      item: {
        title:
          'まずは設定ページからプロフィール写真・カバー画像・自己紹介文を設定しましょう。',
        description:
          'プロフィールを設定することでマッチング率やアポイント獲得率が大きく上がります。',
        link: {
          text: 'プロフィール設定ページへ',
          to: { name: 'plannerSettings' },
          onClick: async () => {
            await logger.ltlPeople.event.click(logger.buildMeta(), {
              data: {
                type: 'dashboard_todo_profile',
              },
            })
          },
        },
      },
      show: props.viewer.todoList.showWriteProfile,
    },
    {
      item: {
        title: '自動アプローチを使ってみましょう。',
        description:
          '毎日1日に1件のペースでおすすめのユーザーに自動でアプローチを送信することができます。',
        link: {
          text: '自動アプローチ設定ページへ',
          to: { name: 'autoPostKartePlannerComment' },
          onClick: async () => {
            await logger.ltlPeople.event.click(logger.buildMeta(), {
              data: {
                type: 'dashboard_todo_auto_post',
              },
            })
          },
        },
      },
      show: props.viewer.todoList.showAutoKartePlannerCommentSetting,
    },
    {
      item: {
        title: 'ユーザー向けマネーセミナーの申込みをしましょう。',
        description:
          '低コストかつ完全成果報酬で効率良くユーザーとのアポが獲得できます。',
        link: {
          text: 'マネーセミナーの詳細はこちら',
          href: 'https://survey.zohopublic.jp/zs/W2D6rl',
          onClick: async () => {
            await logger.ltlPeople.event.click(logger.buildMeta(), {
              data: {
                type: 'dashboard_todo_seminar',
              },
            })
          },
        },
      },
      show: props.viewer.todoList.showSeminar,
    },
  ]

  return links.filter(({ show }) => show).map(({ item }) => item)
})
</script>

<style lang="scss" module>
.list {
  width: 100%;
  padding: 2px 32px;

  &__item {
    &:nth-child(n + 2) {
      border-top: solid 1px $color-border-low-emphasis;
    }
  }
}
</style>
